import React from 'react';
import { ResearchRole } from './shared/global-enums';
import CategoryAddEdit from './components/containers/admin/CategoryAddEdit';
import CategoryList from './components/containers/admin/CategoryList';
import TagAddEdit from './components/containers/admin/TagAddEdit';
import TagList from './components/containers/admin/TagList';
import ArticleAddEdit from './components/containers/admin/ArticleAddEdit';
import ArticleList from './components/containers/admin/ArticleList';
import TemplateList from './components/containers/admin/TemplateList';
import UserEdit from './components/containers/admin/UserEdit';
import UserList from './components/containers/admin/UserList';
import DeskList from './components/containers/admin/DeskList';
import DeskAddEdit from './components/containers/admin/DeskAddEdit';
import ArticlePage from './components/containers/client/ArticlePage';
import ChannelPage from './components/containers/client/ChannelPage';
import PremiumChannelSubscribeSuccessScreen from './components/containers/client/PremiumChannelSubscribeSuccessScreen';
import ChannelsPage from './components/containers/client/ChannelsPage';
import ForYouPage from './components/containers/client/ForYouPage';
import SubscriptionsPage from './components/containers/client/SubscriptionsPage';
import SearchPage from './components/containers/client/SearchPage';
import ManageEmailNotificationsPage from './components/containers/client/ManageEmailNotificationsPage';
import DeskPage from './components/containers/client/DeskPage';
import ContributorPage from './components/containers/client/ContributorPage';
import TagPage from './components/containers/client/TagPage';
import ArchivesPage from './components/containers/client/ArchivesPage';
import BrowseCategoryPage from './components/containers/client/BrowseCategoryPage';
import ArticleAddFromTemplate from './components/containers/admin/ArticleAddFromTemplate'
import TemplateAddEdit from './components/containers/admin/TemplateAddEdit';
import PromotionalContentAddEdit from './components/containers/admin/PromotionalContentAddEdit'
import PromotionalContentList from './components/containers/admin/PromotionalContentList'
import MarketingArticlePage from './components/containers/client/MarketingArticlePage';
import PromotionPage from './components/containers/client/PromotionPage';
import PromotionPageAddEdit from './components/containers/admin/PromotionPageAddEdit'
import PremiumChannelsList from './components/containers/admin/PremiumChannelsList';
import PremiumChannelsAddEdit from './components/containers/admin/PremiumChannelsAddEdit';
import ChannelsStatsPage from './components/containers/admin/ChannelsStatsPage';
import { baseUrls } from './utils/baseUrls.utils';
import PremiumChannelPaymentScreen from './components/containers/client/PremiumChannelPaymentScreen';
import { ChannelSubscribersWrapper } from './components/containers/admin/ChannelsSubscribers/ChannelSubscribersWrapper';
import { premiumChannelsEnabled } from './utils/utils';
import PremiumChannelSubscribeNoClearingAccountConfirm from './components/containers/client/PremiumChannelSubscribeNoClearingAccountConfirm';
import ArticleStatsPage from './components/containers/admin/ArticleStatsPage';
import { PremiumChannelSubscriptionScreen } from './components/containers/client/PremiumChannelSubscriptionScreen';
import { PremiumChannelSubscribeInterestConfirmation } from './components/containers/client/PremiumChannelSubscribeInterestConfirmation';

export interface Route<T> {
	path: string;
	component: React.FC<any>;
	permittedRoles?: ResearchRole[];
	customProps?: T;
}

const articlesRoutes = [
	{
		path: baseUrls.publisher.articles.add,
		component: ArticleAddEdit,
		permittedRoles: [ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.articles.edit,
		component: ArticleAddEdit,
		permittedRoles: [ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.articles.addFromTemplateId,
		component: ArticleAddEdit,
		permittedRoles: [ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.articles.addFromTemplate,
		component: ArticleAddFromTemplate,
		permittedRoles: [ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.articles.stats,
		component: ArticleStatsPage,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.articles.list,
		component: ArticleList,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	}
];

const categoriesRoutes = premiumChannelsEnabled()
	? [
		{
			path: baseUrls.publisher.topics.add,
			component: CategoryAddEdit,
			permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
		},
		{
			path: baseUrls.publisher.topics.edit,
			component: CategoryAddEdit,
			permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
		},
		{
			path: baseUrls.publisher.topics.list,
			component: CategoryList,
			permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
		}
	]
	: [
		{
			path: baseUrls.publisher.categories.add,
			component: CategoryAddEdit,
			permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
		},
		{
			path: baseUrls.publisher.categories.edit,
			component: CategoryAddEdit,
			permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
		},
		{
			path: baseUrls.publisher.categories.list,
			component: CategoryList,
			permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
		}
	];

const promotionalContentRoutes = [
	{
		path: baseUrls.publisher.promotionalContent.add,
		component: PromotionalContentAddEdit,
		permittedRoles: [ResearchRole.Administrator]
	},
	{
		path: baseUrls.publisher.promotionalContent.edit,
		component: PromotionalContentAddEdit,
		permittedRoles: [ResearchRole.Administrator]
	},
	{
		path: baseUrls.publisher.promotionalContent.list,
		component: PromotionalContentList,
		permittedRoles: [ResearchRole.Administrator]
	}
];

const promotionPageRoutes = [
	{
		path: baseUrls.publisher.promotionalPage.add,
		component: PromotionPageAddEdit,
		permittedRoles: [ResearchRole.Administrator]
	},
	{
		path: baseUrls.publisher.promotionalPage.edit,
		component: PromotionPageAddEdit,
		permittedRoles: [ResearchRole.Administrator]
	}
];

const tagsRoutes = [
	{
		path: baseUrls.publisher.tags.add,
		component: TagAddEdit,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.tags.edit,
		component: TagAddEdit,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.tags.list,
		component: TagList,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	}
];

const templatesRoutes = [
	{
		path: baseUrls.publisher.templates.add,
		component: TemplateAddEdit,
		permittedRoles: [ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.templates.edit,
		component: TemplateAddEdit,
		permittedRoles: [ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.templates.list,
		component: TemplateList,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	}
];

const usersRoutes = [
	{
		path: baseUrls.publisher.users.edit,
		component: UserEdit,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.users.list,
		component: UserList,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	}
];

const desksRoutes = [
	{
		path: baseUrls.publisher.desks.add,
		component: DeskAddEdit,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.desks.edit,
		component: DeskAddEdit,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.desks.list,
		component: DeskList,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	}
];

const premiumChannelsRoutes = premiumChannelsEnabled(false) ? [
	{
		path: baseUrls.publisher.premiumChannels.add,
		component: PremiumChannelsAddEdit,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.premiumChannels.edit,
		component: PremiumChannelsAddEdit,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.premiumChannels.list,
		component: PremiumChannelsList,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor, ResearchRole.Contributor]
	},
	{
		path: baseUrls.publisher.premiumChannels.subscribersStats,
		component: ChannelsStatsPage,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.premiumChannels.subscribersStatsMain,
		component: ChannelsStatsPage,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.premiumChannels.addSubscriber,
		component: ChannelSubscribersWrapper,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.premiumChannels.editSubscriber,
		component: ChannelSubscribersWrapper,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor]
	},
	{
		path: baseUrls.publisher.premiumChannels.bulkAddSubscribers,
		component: ChannelSubscribersWrapper,
		permittedRoles: [ResearchRole.Administrator, ResearchRole.Editor]
	}
] : [];

export const publisherRoutes: Route<undefined>[] = [
	...categoriesRoutes,
	...promotionalContentRoutes,
	...promotionPageRoutes,
	...tagsRoutes,
	...templatesRoutes,
	...articlesRoutes,
	...usersRoutes,
	...desksRoutes,
	...premiumChannelsRoutes
];

export const routesWithoutHeader = [
	{
		path: baseUrls.promotion,
		component: PromotionPage,
		permittedRoles: [ResearchRole.Subscriber]
	}
];

export const clientRoutes: Route<string>[] = [
	{
		path: baseUrls.channels.main,
		component: ChannelsPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.browse.article,
		component: ArticlePage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.browse.channel,
		component: ChannelPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.browse.channelAction,
		component: PremiumChannelSubscribeSuccessScreen,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.browse.category,
		component: BrowseCategoryPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.forYou,
		component: ForYouPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.subscriptions,
		component: SubscriptionsPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.search,
		component: SearchPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.emailNotifications,
		component: ManageEmailNotificationsPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.desk.edit,
		component: DeskPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.contributor.edit,
		component: ContributorPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.tag.edit,
		component: TagPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.archives.dateId,
		component: ArchivesPage,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.channelSubscription,
		component: PremiumChannelSubscriptionScreen,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.channelSubscriptionPayment,
		component: PremiumChannelPaymentScreen,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.channelSubscriptionConfirmInterest,
		component: PremiumChannelSubscribeInterestConfirmation,
		permittedRoles: [ResearchRole.Subscriber]
	},
	{
		path: baseUrls.channelSubscriptionConfirmTrial,
		component: PremiumChannelSubscribeNoClearingAccountConfirm,
		permittedRoles: [ResearchRole.Subscriber]
	},
	...routesWithoutHeader
];

export const fullScreenRoutes = [
	{
		path: baseUrls.browse.marketingArticle,
		component: MarketingArticlePage,
		permittedRoles: [ResearchRole.Subscriber]
	}
];
